import styled from "styled-components"

import { colors, spacing, Text } from "@minuthq/meatball-ui-react"

import StarIcon from "src/ui/icons/star.svg"
import StarIconOutline from "src/ui/icons/star-outline.svg"

export function ParadiseDetailsHeading({
  children,
  isFavorite,
  toggleFavorite,
}: {
  children: React.ReactNode
  isFavorite?: boolean
  toggleFavorite?: () => void
}) {
  return (
    <Wrapper>
      <Text variant="heading2">{children}</Text>
      {!!toggleFavorite && isFavorite !== undefined && (
        <FavoriteButton
          isFavorite={isFavorite}
          toggleFavorite={toggleFavorite}
        />
      )}
    </Wrapper>
  )
}

function FavoriteButton({
  isFavorite,
  toggleFavorite,
}: {
  isFavorite: boolean
  toggleFavorite: () => void
}) {
  return (
    <StarWrapper onClick={toggleFavorite} $isStarred={isFavorite}>
      {isFavorite ? (
        <StarIcon fill={colors.systemWarning} width={20} />
      ) : (
        <StarIconOutline width={20} />
      )}
    </StarWrapper>
  )
}

const StarWrapper = styled.div<{ $isStarred: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    opacity: ${({ $isStarred }) => ($isStarred ? 1 : 0)};
    transition: opacity 0.2s ease-in-out;
    cursor: pointer;
  }
`

const Wrapper = styled.div`
  display: flex;
  gap: ${spacing.S};

  &:hover ${StarWrapper} svg {
    opacity: 1;
  }
`
